
import { computed, defineComponent, SetupContext, PropType, toRefs } from "vue";
import NativeClient from "@/client/native-client";
import FridgeDetailsDrumPicker from "./FridgeDetailsDrumPicker.vue";

export default defineComponent({
  name: "FridgeDetailsCoolingAssistSettingsItem",
  components: {
    FridgeDetailsDrumPicker
  },
  props: {
    /** 添字 */
    index: {
      type: Number,
      required: true
    },
    /** 種類名 */
    modeName: {
      type: String,
      required: true
    },
    /** 説明文 */
    descriptionText: {
      type: String,
      required: true
    },
    /** 目安時間 */
    note: {
      type: String,
      required: true
    },
    /** 秒有効／無効 */
    isSecondsValid: {
      type: Boolean,
      required: true
    },
    /** 分初期値 */
    initialMinutes: {
      type: Number,
      required: true
    },
    /** 秒初期値 */
    initialSeconds: {
      type: Number,
      default: 0
    },
    /** 分最小値 */
    minMinutes: {
      type: Number,
      required: true
    },
    /** 分最大値 */
    maxMinutes: {
      type: Number,
      required: true
    },
    /** 秒最小値 */
    minSeconds: {
      type: Number,
      default: 0
    },
    /** 秒最大値 */
    maxSeconds: {
      type: Number,
      default: 0
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeDetailsCoolingAssistSettingsItem setup");

    const contentsTitleText = "運転時間";

    // 保存
    const { initialMinutes } = toRefs(props);
    const { initialSeconds } = toRefs(props);
    let storeMinutes = initialMinutes.value;
    let storeSeconds = initialSeconds.value;

    const selectTime =  (minutes: number, seconds: number) => {
      NativeClient.sendDebugLog("FridgeDetailsCoolingAssistSettingsItem selectTime()");
      storeMinutes = minutes;
      storeSeconds = seconds;
    };

    // ボタン
    const okButtonText = "OK";
    const okButtonAction = () => {
      NativeClient.sendDebugLog("FridgeDetailsCoolingAssistSettingsItem okButtonAction() index = " + props.index + ", minutes = " + storeMinutes + ", seconds = " + storeSeconds);
      context.emit("select-time", props.index, storeMinutes, storeSeconds);
    };

    // HorizontalPagingがタッチ・イベントを奪い、クリックが反応しないため、クリックをtouchStart、touchEndで検出する
    const touchStart = (event: TouchEvent) => {
      event.stopPropagation();
    };
    const touchMove = (event: TouchEvent)=> {
      event.preventDefault();
      event.stopPropagation();
    }
    const touchEnd = (event: TouchEvent) => {
      event.stopPropagation();
    };

    return {
      contentsTitleText,
      selectTime,
      okButtonText,
      okButtonAction,
      touchStart,
      touchMove,
      touchEnd
    };
  }
});
